<script lang="ts"
        setup
>
const { data: page } = useErrorPage()
</script>

<template>
  <svg
    id="be055ddd-85eb-4df0-9de6-0b8a0d661d22"
    :data-name="page?.error?.['429']?.title"
    height="100%"
    viewBox="0 0 959.26162 684.45681"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>
      {{ page?.error?.['429']?.title }}
    </title>
    <path
      d="M590.83233,107.77159,327.73,250.2827a66.93013,66.93013,0,1,1-117.65045,63.7262l-89.71039,48.59222L352.74676,791.6137,823.20989,536.78423Z"
      fill="#f2f2f2"
      transform="translate(-120.36919 -107.77159)"
    />
    <polygon
      fill="currentColor"
      points="137.144 333.711 326.757 363.893 311.352 460.675 163.217 437.095 157.244 474.623 145.1 434.212 121.739 430.493 137.144 333.711"
    />
    <polygon
      opacity="0.2"
      points="137.144 333.711 326.757 363.893 311.352 460.675 163.217 437.095 157.244 474.623 145.1 434.212 121.739 430.493 137.144 333.711"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="translate(494.55652 911.28923) rotate(-170.95582)"
      width="116"
      x="289.76145"
      y="480.21327"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="translate(485.20293 950.05215) rotate(-170.95582)"
      width="116"
      x="286.61753"
      y="499.96462"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="translate(475.84934 988.81508) rotate(-170.95582)"
      width="116"
      x="283.47361"
      y="519.71597"
    />
    <polygon
      fill="currentColor"
      points="124.156 472.652 300.381 396.436 339.283 486.384 201.607 545.928 216.691 580.805 184.77 553.21 163.058 562.6 124.156 472.652"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="translate(765.49533 846.73624) rotate(156.61192)"
      width="116"
      x="286.14948"
      y="563.93275"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="translate(788.00814 878.78999) rotate(156.61192)"
      width="116"
      x="294.08862"
      y="582.28949"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="matrix(-0.91784, 0.39696, -0.39696, -0.91784, 810.52096, 910.84374)"
      width="116"
      x="302.02776"
      y="600.64624"
    />
    <polygon
      fill="currentColor"
      points="151.156 296.652 327.381 220.436 366.283 310.384 228.607 369.928 243.691 404.805 211.77 377.21 190.058 386.6 151.156 296.652"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="translate(747.4125 498.47906) rotate(156.61192)"
      width="116"
      x="313.14948"
      y="387.93275"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="translate(769.92531 530.53281) rotate(156.61192)"
      width="116"
      x="321.08862"
      y="406.28949"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="matrix(-0.91784, 0.39696, -0.39696, -0.91784, 792.43813, 562.58655)"
      width="116"
      x="329.02776"
      y="424.64624"
    />
    <path
      d="M284.96092,186.72841l704.91044,30.12437s110.45606,351.45108,28.11609,502.073l-667.757,73.30266S490.81083,531.15046,284.96092,186.72841Z"
      fill="#3f3d56"
      transform="translate(-120.36919 -107.77159)"
    />
    <line
      fill="none"
      stroke="#2f2e41"
      stroke-miterlimit="10"
      stroke-width="2"
      x1="272.03534"
      x2="866.48974"
      y1="242.6326"
      y2="232.59114"
    />
    <line
      fill="none"
      stroke="#2f2e41"
      stroke-miterlimit="10"
      stroke-width="2"
      x1="288.10168"
      x2="888.58095"
      y1="288.82331"
      y2="276.77356"
    />
    <line
      fill="none"
      stroke="#2f2e41"
      stroke-miterlimit="10"
      stroke-width="2"
      x1="178.86614"
      x2="875.14964"
      y1="103.69392"
      y2="128.17829"
    />
    <path
      d="M823.05079,571.31837c0,1.49-.01,2.98-.05,4.45v.01c-.06,3.64-.2,7.22-.43,10.78q-.36,5.73-.98,11.31006c-4.05,36.37-16.27,68.06-33.42,89.72-9.72,12.29-21.03,21.36-33.34,26.24a58.44876,58.44876,0,0,1-11.65,3.29,55.12844,55.12844,0,0,1-9.37.8c-14.73,0-28.63-5.86005-40.87-16.26-23.65-20.05-41.15-56.97-46.58-101.08v-.01c-.92-7.46-1.5-15.11-1.69-22.93q-.09-3.135-.09-6.32c0-80.97,39.95-146.61,89.23-146.61,11.67,0,22.82,3.68,33.04,10.38.30005.19.6.39.89.6a86.97706,86.97706,0,0,1,15.35,13.38,112.59642,112.59642,0,0,1,8.24,10.15,134.24885,134.24885,0,0,1,8.92,14.22c2.24,4.1,4.35,8.42,6.29,12.93v.01q3.03,6.96,5.55,14.5v.01a214.02745,214.02745,0,0,1,9.86,47.41C822.6808,555.79841,823.05079,563.48841,823.05079,571.31837Z"
      opacity="0.2"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M339.63884,198.273c.76488,2.868-.153,6.19482-2.04627,7.42823-1.889,1.23064-4.03484-.08927-4.79661-2.94561s.14644-6.17688,2.03238-7.41914C336.71851,194.0914,338.874,195.405,339.63884,198.273Z"
      fill="currentColor"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M355.68128,198.02186c.76487,2.868-.153,6.19483-2.04627,7.42823-1.889,1.23065-4.03484-.08926-4.79662-2.94561s.14645-6.17688,2.03238-7.41913C352.761,193.8403,354.9164,195.15389,355.68128,198.02186Z"
      fill="currentColor"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M323.59641,198.52405c.76487,2.868-.153,6.19483-2.04628,7.42824-1.889,1.23064-4.03483-.08927-4.79661-2.94562s.14644-6.17688,2.03238-7.41913C320.67607,194.34249,322.83153,195.65608,323.59641,198.52405Z"
      fill="currentColor"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M824.39466,486.78525l5.19055,15.44525,5.61952.43374-5.05194-38.503c1.877-24.31842-8.27453-45.77251-32.59306-47.64954l-.00025,0a30.8366,30.8366,0,0,0-33.118,28.37205l-2.868,37.1573a14.89558,14.89558,0,0,0,13.705,15.99776l43.59981,3.36525Z"
      fill="#2f2e41"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M829.87533,574.75361s4.61562,12.52812,12.52812,14.50625,66.59687,15.825,66.59687,15.825,51.43125,1.31875,35.60625,12.52812-41.54062,0-41.54062,0-75.16875-9.23125-81.10312-19.12187a133.28551,133.28551,0,0,1-9.89063-21.1Z"
      fill="#fbbebe"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M804.81908,519.36611s37.58437,61.32187,32.96875,62.64062-47.475,15.16563-49.45313,9.89063-1.97812-29.67188-1.97812-29.67188Z"
      fill="#ff6584"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M804.81908,519.36611s37.58437,61.32187,32.96875,62.64062-47.475,15.16563-49.45313,9.89063-1.97812-29.67188-1.97812-29.67188Z"
      opacity="0.15"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M701.56074,499.06937l-55.78662,77.56824s-37.09592,33.13253-23.19291,37.11164,35.97035-28.10715,35.97035-28.10715l64.29965-81.19854Z"
      fill="#fbbebe"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M816.02845,470.57236s-16.48437,25.05625-15.16562,30.99063c0,0-1.31875,3.95625.65937,6.59375s1.31875,18.4625,1.31875,18.4625l-6.59375,9.23125-8.57187-28.35313-3.95625-30.33125s8.90156-12.19843,7.58281-18.13281S816.02845,470.57236,816.02845,470.57236Z"
      fill="#fbbebe"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M788.17079,687.58839c-9.72,12.29-21.03,21.36-33.34,26.24a58.44876,58.44876,0,0,1-11.65,3.29c2.11-46.81006,4.54-88.56006,6.25-92.25,3.96-8.57,14.51-11.87006,14.51-11.87006s1.04,2.79,2.78,7.64C771.23078,633.27839,780.45082,659.91841,788.17079,687.58839Z"
      fill="#ff6584"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M788.17079,687.58839c-9.72,12.29-21.03,21.36-33.34,26.24a58.44876,58.44876,0,0,1-11.65,3.29c2.11-46.81006,4.54-88.56006,6.25-92.25,3.96-8.57,14.51-11.87006,14.51-11.87006s1.04,2.79,2.78,7.64C771.23078,633.27839,780.45082,659.91841,788.17079,687.58839Z"
      opacity="0.15"
      transform="translate(-120.36919 -107.77159)"
    />
    <circle
      cx="687.08738"
      cy="342.36014"
      fill="#fbbebe"
      r="24.39687"
    />
    <path
      d="M796.91084,562.88838c-4.56006,4.34-7.91,7.54-10.37006,9.98-5,4.93994-6.34,6.71-6.78,8.48-.66,2.64-3.95,2.64-3.95,2.64l-9.09,36.65-10.04,40.49s-.65,22.5-1.85,52.7a58.44876,58.44876,0,0,1-11.65,3.29,55.12844,55.12844,0,0,1-9.37.8c-14.73,0-28.63-5.86005-40.87-16.26.17-38.62-.22-78.11-.22-78.11s-10.55-17.14,25.72-50.77c0,0,5.72-16.68,11.64-33.43,5.95-16.88,12.1-33.83,12.76-33.83.44,0,3.59-4.03,7.59-9.4,3.51-4.7,7.68-10.44,11.24-15.41,4.59-6.36,8.2-11.45,8.2-11.45s10.83,0,15.47,5.53a8.50525,8.50525,0,0,1,1.68,3.04c1.12,3.65,3.68,12.56,6.25,21.6,3.45,12.17,6.93,24.55,6.93,24.55l1.77-14.88s5.49,7.63,5.49,13.56c0,.32.01.68.01995,1.09C807.77082,530.85841,810.0008,550.4084,796.91084,562.88838Z"
      fill="#ff6584"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M777.7847,474.52861l-7.9125-5.275s-32.96874,19.78125-56.04687,21.1-22.41875,14.50625-13.1875,23.7375,45.49687,40.88125,46.81562,32.96875S777.7847,474.52861,777.7847,474.52861Z"
      fill="#ff6584"
      transform="translate(-120.36919 -107.77159)"
    />
    <path
      d="M821.25225,419.68164c-5.30337-1.78861-18.13191-2.74071-20.00866-2.88556A34.53141,34.53141,0,0,0,764.1571,448.5677l-16.69141,47.3244,25.22916,1.94731,6.06709-17.58525,5.26177,18.45967,12.7005.98029,1.92412-10.70019,3.4661,11.11623,14.14664,1.09191c-8.74461-24.79053-12.69406-47.07712,2.26672-59.48983,9.30071,2.00581,17.42262.10011,19.10778-4.89629C839.577,431.05936,832.242,423.3881,821.25225,419.68164Z"
      fill="#2f2e41"
      transform="translate(-120.36919 -107.77159)"
    />
    <polygon
      fill="currentColor"
      points="767.262 367.957 959.262 367.957 959.262 465.957 809.262 465.957 809.262 503.957 790.917 465.957 767.262 465.957 767.262 367.957"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="translate(1846.89242 901.68522) rotate(-180)"
      width="116"
      x="925.63081"
      y="499.72841"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="translate(1846.89242 941.68522) rotate(-180)"
      width="116"
      x="925.63081"
      y="519.72841"
    />
    <rect
      fill="#f2f2f2"
      height="10"
      transform="translate(1846.89242 981.68522) rotate(-180)"
      width="116"
      x="925.63081"
      y="539.72841"
    />
    <rect
      fill="currentColor"
      height="50"
      opacity="0.2"
      transform="translate(-24.12537 -278.46225) rotate(14.95654)"
      width="50"
      x="673.28954"
      y="256.25131"
    />
    <circle
      cx="591.03702"
      cy="193.86745"
      fill="none"
      r="14.75556"
      stroke="#3f3d56"
      stroke-miterlimit="10"
      stroke-width="2"
    />
  </svg>
</template>
